import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IStruxTagGpsPathQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  infuseId: Types.Scalars['String']['input']
  from: Types.Scalars['DateTime']['input']
  to: Types.Scalars['DateTime']['input']
  maxPoints?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type IStruxTagGpsPathQuery = {
  struxTagGpsPath?: {
    segments: Array<{
      points: Array<{
        timestamp: any
        latitude: number
        longitude: number
        height?: number | null
        hAcc: number
      }>
    }>
    summary: {
      pointCount: number
      distanceMeters: number
      maxSpeedMps?: number | null
      averageSpeedMps?: number | null
      startedAt?: any | null
      endedAt?: any | null
    }
  } | null
}

export const StruxTagGpsPathDocument = gql`
  query StruxTagGpsPath(
    $projectId: ObjectId!
    $infuseId: String!
    $from: DateTime!
    $to: DateTime!
    $maxPoints: Int
  ) {
    struxTagGpsPath(
      projectId: $projectId
      infuseId: $infuseId
      from: $from
      to: $to
      maxPoints: $maxPoints
    ) {
      segments {
        points {
          timestamp
          latitude
          longitude
          height
          hAcc
        }
      }
      summary {
        pointCount
        distanceMeters
        maxSpeedMps
        averageSpeedMps
        startedAt
        endedAt
      }
    }
  }
`

/**
 * __useStruxTagGpsPathQuery__
 *
 * To run a query within a React component, call `useStruxTagGpsPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useStruxTagGpsPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStruxTagGpsPathQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      infuseId: // value for 'infuseId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      maxPoints: // value for 'maxPoints'
 *   },
 * });
 */
export function useStruxTagGpsPathQuery(
  baseOptions: Apollo.QueryHookOptions<
    IStruxTagGpsPathQuery,
    IStruxTagGpsPathQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IStruxTagGpsPathQuery, IStruxTagGpsPathQueryVariables>(
    StruxTagGpsPathDocument,
    options,
  )
}
export function useStruxTagGpsPathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IStruxTagGpsPathQuery,
    IStruxTagGpsPathQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IStruxTagGpsPathQuery,
    IStruxTagGpsPathQueryVariables
  >(StruxTagGpsPathDocument, options)
}
export type StruxTagGpsPathQueryHookResult = ReturnType<
  typeof useStruxTagGpsPathQuery
>
export type StruxTagGpsPathLazyQueryHookResult = ReturnType<
  typeof useStruxTagGpsPathLazyQuery
>
export type StruxTagGpsPathQueryResult = Apollo.QueryResult<
  IStruxTagGpsPathQuery,
  IStruxTagGpsPathQueryVariables
>
